//import React, { useState, useEffect } from 'react';
//import authService from './api-authorization/AuthorizeService'
//import Players from './features/players/Players';
//import UpdateEventGames from './features/games/UpdateEventGames'
//import EventsByGameSource from './features/games/EventsByGameSource'
//import TagPlayerGames from './features/games/TagPlayerGames'
//import OnlineGameDownloader from './features/GameDowloaders/OnlineGameDownloader';
//import WhoDownloadedMyGames from './WhoDownloadedMyGames';
//import axios from 'axios';

//export default function Tools(props) {
    //const [authenticated, setAuthenticated] = useState(false);
    //const [isAdmin, setIsAdmin] = useState(false);
    //const [isOrganizer, setIsOrganizer] = useState(false);
    //const [isPlayer, setIsPlayer] = useState(false);
    //const [userName, setUserName] = useState();
    //const [idType, setIdType] = useState();
    //const [playerId, setPlayerId] = useState();
    //const [userRole, setUserRole] = useState("");
    //const [isSupporter, setIsSupporter] = useState(false);
    //const [isGameContributor, setIsGameContributor] = useState(false);
    //const [supportLevel, setSupportLevel] = useState(0);


    //const GetMySupporterStatus = async (token) => {
    //    var headers = {
    //        headers: { 'Authorization': `Bearer ${token}` }
    //    }
    //    axios.get('/api/NACHUsers/GetMySupporterStatusExpDateUtc', headers).then((response) => {
    //        setIsSupporter(response.data.isSupporter);
    //        setSupportLevel(response.data.supportLevel);
    //        //setIsGameContributor(response.data.isGameContributor);
    //        return response.data.isSupporter;
    //    }).catch((error) => {
    //        console.log(JSON.stringify(error));
    //        setIsSupporter(false);
    //        return false;
    //    });
    //};

    //useEffect( () => {
    //    async function fetchData() {
    //        setAuthenticated(await authService.isAuthenticated());
    //        var ttt = await authService.getAccessToken();
    //        await GetMySupporterStatus(ttt);
    //        var user = await authService.getUser();
    //        if (user != null) {
    //            var role = user.role;
    //            setUserName(user.sub);
    //            if (user.sub.includes("FIDE")) {
    //                setIsPlayer(true);
    //                setIdType("FIDE");
    //                setPlayerId(user.sub.replace("FIDE", ""));
    //            } else if (user.sub.includes("Affiliate")) {
    //                setIsPlayer(false);
    //                setIsOrganizer(true);
    //            }
    //            else if (user.sub.includes("USCF")) {
    //                setIsPlayer(true);
    //                setIdType("USCF");
    //                setPlayerId(user.sub.replace("USCF", ""));
    //            }

    //            setUserRole(role);
    //            if (role.includes("Administrators"))
    //                setIsAdmin(true);
    //            if (role.includes("GameContributors"))
    //                setIsGameContributor(true);
    //        }
    //    }
    //    fetchData();
    //}, []);

//        return (
//            <div>
//                {isPlayer &&
//                    <WhoDownloadedMyGames/>
//                }
//                {isPlayer &&
//                    <OnlineGameDownloader />
//                }

//                {(isOrganizer || isAdmin) &&
//                    <Players/>
//                }

//                {isAdmin  &&
//                    <UpdateEventGames/>
//                }

//                {isAdmin &&
//                    <EventsByGameSource/>
//                }

//                {(isAdmin || isGameContributor) &&
//                    <TagPlayerGames />
//                }
//            </div>
//        );
//}


import React, { useState, useEffect } from 'react';
import { Tabs, Tab, Box, useTheme } from '@mui/material';
import axios from 'axios';
import authService from './api-authorization/AuthorizeService';
import Players from './features/players/Players';
import UpdateEventGames from './features/games/UpdateEventGames';
import EventsByGameSource from './features/games/EventsByGameSource';
import TagPlayerGames from './features/games/TagPlayerGames';
import OnlineGameDownloader from './features/GameDowloaders/OnlineGameDownloader';
import WhoDownloadedMyGames from './WhoDownloadedMyGames';
import EventGames from './EventGames';


export default function Tools() {
    const [authenticated, setAuthenticated] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);
    const [isOrganizer, setIsOrganizer] = useState(false);
    const [isPlayer, setIsPlayer] = useState(false);
    const [userName, setUserName] = useState();
    const [idType, setIdType] = useState();
    const [playerId, setPlayerId] = useState();
    const [userRole, setUserRole] = useState("");
    const [isSupporter, setIsSupporter] = useState(false);
    const [isGameContributor, setIsGameContributor] = useState(false);
    const [supportLevel, setSupportLevel] = useState(0);
    const [selectedTab, setSelectedTab] = useState(0);

    const theme = useTheme();

    const GetMySupporterStatus = async (token) => {
        const headers = {
            headers: { Authorization: `Bearer ${token}` },
        };
        try {
            const response = await axios.get(
                '/api/NACHUsers/GetMySupporterStatusExpDateUtc',
                headers
            );
            setIsSupporter(response.data.isSupporter);
            setSupportLevel(response.data.supportLevel);
        } catch (error) {
            console.error(error);
            setIsSupporter(false);
        }
    };

    useEffect(() => {
        async function fetchData() {
            setAuthenticated(await authService.isAuthenticated());
            const token = await authService.getAccessToken();
            await GetMySupporterStatus(token);
            const user = await authService.getUser();
            if (user != null) {
                const role = user.role;
                setUserName(user.sub);
                if (user.sub.includes('FIDE')) {
                    setIsPlayer(true);
                    setIdType('FIDE');
                    setPlayerId(user.sub.replace('FIDE', ''));
                } else if (user.sub.includes('Affiliate')) {
                    setIsPlayer(false);
                    setIsOrganizer(true);
                } else if (user.sub.includes('USCF')) {
                    setIsPlayer(true);
                    setIdType('USCF');
                    setPlayerId(user.sub.replace('USCF', ''));
                }

                setUserRole(role);
                if (role.includes('Administrators')) setIsAdmin(true);
                if (role.includes('GameContributors')) setIsGameContributor(true);
            }
        }
        fetchData();
    }, []);

    const availableTabs = [
        {
            label: 'Player Tools',
            condition: isPlayer,
            content: (
                <div>
                    <OnlineGameDownloader />
                    <WhoDownloadedMyGames />
                </div>
            ),
        },
        {
            label: 'Top Players',
            condition: isOrganizer || isAdmin,
            content: <Players />,
        },
        {
            label: 'Update Event Games',
            condition: isAdmin,
            content: <UpdateEventGames />,
        },
        {
            label: 'Events by Game Source',
            condition: isAdmin,
            content: <EventsByGameSource />,
        },
        {
            label: 'Event Games',
            condition: isAdmin,
            content: <EventGames />,
        },
        {
            label: 'Tag Player Games',
            condition: isAdmin || isGameContributor,
            content: <TagPlayerGames />,
        },
    ];

    // Filter tabs based on user role conditions
    const filteredTabs = availableTabs.filter((tab) => tab.condition);

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
            {/* Tabs Navigation */}
            <Tabs
                value={selectedTab}
                onChange={(event, newValue) => setSelectedTab(newValue)}
                variant="scrollable"
                scrollButtons="auto"
                sx={{
                    borderBottom: 1,
                    borderColor: 'divider',
                    backgroundColor: theme.palette.background.default,
                }}
            >
                {filteredTabs.map((tab, index) => (
                    <Tab
                        key={tab.label}
                        label={tab.label}
                        sx={{
                            fontWeight: 'bold',
                            borderRadius: 1,
                            mx: 1,
                            textTransform: 'none',
                            backgroundColor: selectedTab === index
                                ? theme.palette.primary.main
                                : theme.palette.background.paper,
                            color: selectedTab === index
                                ? theme.palette.primary.contrastText
                                : theme.palette.text.primary,
                            '&:hover': {
                                border: `1px solid ${theme.palette.primary.main}`,
                            },
                            '&.Mui-selected': {
                                color: theme.palette.primary.contrastText,
                            },
                        }}
                    />
                ))}
            </Tabs>

            {/* Content Area */}
            <Box sx={{ flexGrow: 1, overflow: 'auto', p: 3 }}>
                {filteredTabs[selectedTab]?.content || (
                    <div>Select a tab to view content</div>
                )}
            </Box>
        </Box>
    );
}
